<template>
    <transition name="fade">
        <div v-if="visible" class="overlay">
            <!-- Ánh sáng xoáy -->
            <div class="light-spiral"></div>

            <!-- Hạt ánh sáng -->
            <div class="particles"></div>

            <!-- Logo xuất hiện -->
            <img src="@/assets/images/logo.webp" alt="Loading" class="logo-summon" />

            <!-- Text nhỏ -->
            <p class="loading-text">{{ message }}</p>
        </div>
    </transition>
</template>

<script setup>
    import { ref, onMounted, onUnmounted } from 'vue'
    import { EventBus } from '@/utils/eventBus'

    const visible = ref(false)
    const message = ref('Preparing your vision')

    function showLoading(msg = 'Preparing your vision') {
        message.value = msg
        visible.value = true
    }

    function hideLoading() {
        visible.value = false
    }

    onMounted(() => {
        EventBus.on('loading:show', showLoading)
        EventBus.on('loading:hide', hideLoading)
    })

    onUnmounted(() => {
        EventBus.off('loading:show', showLoading)
        EventBus.off('loading:hide', hideLoading)
    })
</script>

<style scoped>
    /* ===== FADE ===== */
    .fade-enter-active,
    .fade-leave-active {
        transition: opacity 0.5s ease;
    }

    .fade-enter-from,
    .fade-leave-to {
        opacity: 0;
    }

    /* ===== OVERLAY ===== */
    .overlay {
        position: fixed;
        inset: 0;
        background:
            radial-gradient(circle at center,
                #ffffff 0%,
                #f5f8ff 45%,
                #e8efff 70%,
                #dde6ff 100%);
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        overflow: hidden;
        z-index: 99999;
    }

    /* ===== LIGHT SPIRAL ===== */
    .light-spiral {
        position: absolute;
        width: 520px;
        height: 520px;
        border-radius: 50%;
        background:
            conic-gradient(from 0deg,
                rgba(255, 255, 255, 0),
                rgba(180, 200, 255, 0.45),
                rgba(255, 255, 255, 0));
        animation: spin 6s linear infinite;
        filter: blur(1px);
    }

    @keyframes spin {
        to {
            transform: rotate(360deg);
        }
    }

    /* ===== PARTICLES ===== */
    .particles {
        position: absolute;
        inset: 0;
        background-image:
            radial-gradient(circle, rgba(255, 255, 255, 0.9) 1px, transparent 1px),
            radial-gradient(circle, rgba(200, 220, 255, 0.8) 1px, transparent 1px);
        background-size: 80px 80px, 120px 120px;
        animation: floatParticles 10s linear infinite;
        opacity: 0.35;
    }

    @keyframes floatParticles {
        from {
            background-position: 0 0, 0 0;
        }

        to {
            background-position: 300px 600px, -400px 800px;
        }
    }

    /* ===== LOGO ===== */
    .logo-summon {
        width: 140px;
        height: 140px;
        object-fit: contain;
        z-index: 2;

        /* Glow luôn có */
        filter:
            drop-shadow(0 0 6px rgba(120, 150, 255, 0.55)) drop-shadow(0 0 18px rgba(160, 190, 255, 0.45)) drop-shadow(0 0 32px rgba(200, 220, 255, 0.35));

        animation:
            summonFocus 1.6s cubic-bezier(0.2, 0.9, 0.3, 1.05) forwards,
            glow 2.6s ease-in-out infinite;
    }


    @keyframes summon {
        0% {
            transform: scale(0.2);
            opacity: 0;
            filter: blur(8px);
        }

        60% {
            transform: scale(1.15);
            opacity: 1;
            filter: blur(0);
        }

        100% {
            transform: scale(1);
        }
    }

    /* ===== TEXT ===== */
    .loading-text {
        margin-top: 18px;
        font-size: 13px;
        letter-spacing: 0.5px;
        color: rgba(60, 80, 140, 0.75);
        font-weight: 500;

        opacity: 0;
        animation: fadeUp 1s ease forwards;
        animation-delay: 1s;
    }

    @keyframes fadeUp {
        from {
            opacity: 0;
            transform: translateY(6px);
        }

        to {
            opacity: 1;
            transform: translateY(0);
        }
    }
</style>